import React from 'react'
import { components, constants, useTranslation } from 'cng-web-lib'
import StatusNotificationFormProperties from './StatusNotificationFormProperties'
import Box from '@material-ui/core/Box'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  form: { CngForm },
  CngDialog
} = components

const { FormState } = constants

function StatusNotificationDialog(props) {
  const {
    open,
    onAddStatusNotification,
    onClose,
    onEditStatusNotification,
    manifestId,
    showNotification,
    statusNotification,
    type
  } = props

  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()

  const { initialValues, makeValidationSchema } =
    StatusNotificationFormProperties.formikProps

  return (
    <CngDialog
      dialogContent={
        <CngForm
          fieldLevel='form'
          formikProps={{
            initialValues: {
              ...(statusNotification || initialValues),
              shipmentId: manifestId
            },
            makeValidationSchema: makeValidationSchema,
            onSubmit: (data) => {
              if (type === 'EDIT') {
                onEditStatusNotification(data)
              } else {
                delete data.id

                onAddStatusNotification(data)
              }
              onClose()
            }
          }}
          formState={FormState.COMPLETED}
          renderBodySection={(labelMap, shouldHideMap) => (
            <StatusNotificationFormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          renderButtonSection={() => (
            <Box display='flex' justifyContent='flex-end'>
              <CngButton color='primary' size='medium' type='submit'>
                {aciHighwayManifestTranslationText.saveButton}
              </CngButton>
            </Box>
          )}
        />
      }
      dialogTitle={aciHighwayManifestTranslationText.title}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='md'
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      open={open}
      shouldShowCloseButton
    />
  )
}

export default StatusNotificationDialog
